import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";

import { ChangeDetectionStrategy, Component, computed, inject, input, resource } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterLink } from "@angular/router";

import { AlertsService } from "../../../apis/networkdashboard/rest/services";

@Component({
  selector: "wired-service-tile",
  templateUrl: "wired-service-tile.html",
  styleUrl: "../service-tile/service-tile.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, MatTooltipModule, NgxSkeletonLoaderModule, RouterLink, TranslatePipe],
})
export class WiredServiceTile {
  protected serviceUrl = input.required<string>();
  protected serviceIcon = input.required<string>();
  protected serviceTitle = input.required<string>();
  protected subscriptionCount = input.required<number>();
  protected isLoading = input.required<boolean>();

  private readonly alertsService = inject(AlertsService);

  protected serviceRoute = computed(() => ["/diensten", this.serviceUrl()]);

  private readonly wiredAlerts = resource<unknown[], undefined>({
    loader: () => this.alertsService.getCustomerAlerts().catch(() => []),
  });

  protected alertCount = computed(() => this.wiredAlerts.value()?.length ?? 0);
}
